<div class="wf-peppol-items__header">
  <wui-filter-panel
    [config]="filterDefinitions()"
    [activeFiltersState]="activeFiltersState()"
    (change)="onFiltersChange($event)"
  />

  <div class="wf-peppol-items__header-end">
    <wf-input-search [value]="search()" (change)="onSearch($event)" />
  </div>
</div>

<div class="wf-peppol-items__table-holder">
  <wf-smart-table
    interactive
    showActions
    hasRowAction
    [data]="dataSource()"
    [cellTemplate]="cellTpl"
    [rowHeight]="72"
    [rowActionConfigFactory]="control().actionsFactory"
    [loading]="loading()"
    [sort]="sort()"
    (sortChange)="changeSort($event)"
    (changePage)="changePage($event)"
    (sizesChange)="sizesChange($event)"
    (rowAction)="onRowAction($event)"
    (rowClick)="onRowClick($event.value)"
  >
    <ng-template #cellTpl let-row let-column="column">
      @switch (column.key) {
        @case ('direction') {
          @if (peppolDirectionConfig[row.direction]; as cfg) {
            <div
              class="wf-peppol-items__status-cell"
              [wuiTooltip]="cfg.label | translate"
            >
              <wf-icon
                iconClass="small"
                [iconName]="cfg.icon"
                [class]="'wf-peppol-items__status-cell-icon ' + cfg.colorClass"
              />
            </div>
          }
        }
        @case ('status') {
          @if (peppolStatusConfig[row.status]; as cfg) {
            <div
              class="wf-peppol-items__status-cell"
              [wuiTooltip]="cfg.label | translate"
            >
              <wf-icon
                iconClass="small"
                [iconName]="cfg.icon"
                [class]="'wf-peppol-items__status-cell-icon ' + cfg.colorClass"
              />
            </div>
          }
        }

        @case ('document') {
          @let documentConfig =
            row.documentId
              ? peppolDocumentConfig.connected
              : peppolDocumentConfig.unconnected;
          <div
            class="wf-peppol-items__status-cell"
            [wuiTooltip]="documentConfig.label | translate"
          >
            <wf-icon
              iconClass="small"
              [iconName]="documentConfig.icon"
              [class]="
                'wf-peppol-items__status-cell-icon ' + documentConfig.colorClass
              "
            />
          </div>
        }

        @case ('sender') {
          <ng-container
            [ngTemplateOutlet]="partnerTpl"
            [ngTemplateOutletContext]="{ $implicit: row.partner }"
          />
        }

        @case ('receiver') {
          <ng-container
            [ngTemplateOutlet]="partnerTpl"
            [ngTemplateOutletContext]="{ $implicit: row.partner }"
          />
        }

        @case ('partner') {
          <ng-container
            [ngTemplateOutlet]="partnerTpl"
            [ngTemplateOutletContext]="{ $implicit: row.partner }"
          />
        }

        @case ('invoiceType') {
          @if (row.invoiceType) {
            @let invoiceTypeLabel =
              'DocumentInvoiceType_' + row.invoiceType | translate;
            <div class="truncate-long-text" [wuiTooltip]="invoiceTypeLabel">
              {{ invoiceTypeLabel }}
            </div>
          }
        }

        @case ('lastAction') {
          @if (peppolStatusConfig[row.status]; as statusConfig) {
            <div class="wf-peppol-items__last-action-cell">
              <span class="wf-text-sm-medium">{{
                statusConfig.label | translate
              }}</span>

              @if (row.statusChangedAt) {
                <span
                  class="wf-peppol-items__last-action-cell-date wf-text-sm-regular"
                  >{{ row.statusChangedAt | date: 'dd.MM.yyyy HH:mm' }}</span
                >
              }
            </div>
          }
        }

        @case ('receivedDate') {
          <span>{{ row.createdAt | date: 'dd.MM.yyyy HH:mm' }}</span>
        }

        @case ('sentDate') {
          <span>{{ row.createdAt | date: 'dd.MM.yyyy HH:mm' }}</span>
        }

        @case ('date') {
          <span>{{ row.createdAt | date: 'dd.MM.yyyy HH:mm' }}</span>
        }

        @default {
          {{ row[column.key] }}
        }
      }

      <ng-template #partnerTpl let-partner>
        <div class="wf-peppol-items__partner-cell">
          <span class="wf-peppol-items__partner-cell-name wf-text-sm-medium">{{
            partner.name
          }}</span>
          <span class="wf-peppol-items__partner-cell-id wf-text-sm-regular">{{
            partner.peppolId
          }}</span>
        </div>
      </ng-template>
    </ng-template>
  </wf-smart-table>
</div>
